import { FALLBACK_LITERALS } from './fallback.js';

export function createTranslator(literals = {}) {
    const dictionary = { ...FALLBACK_LITERALS, ...literals };

    return function t(key, fallback = key) {
        return dictionary[key] ?? fallback;
    };
}
